import { ApplicationController } from "../application_controller";

// Filters of a list on phones and tablets: the children of the element marked data-mobile-filters-keep
// (the search) stay visible, the other filters open with the "Filters (N)" button of
// shared/_mobile_filters_toolbar. While they are open, change/keyup/input events of the filters are held back
// in the capture phase, so the list is not reloaded on every tap; "Apply" dispatches one change event and the
// page controller reads all the filter values as usual, it needs no changes.
// N counts the named select and input fields of the hidden filters that have a value.
export default class extends ApplicationController {
  static targets = ["toggle", "count"]

  connect() {
    this.element.classList.add("mobile-filters");
    this.onEvent = event => this.holdBack(event);
    ["change", "keyup", "input"].forEach(type => this.element.addEventListener(type, this.onEvent, true));
    // the calendars and the selects put their initial values a moment after the page is shown
    this.countTimer = setTimeout(() => this.updateCount(), 500);
  }

  disconnect() {
    clearTimeout(this.countTimer);
    ["change", "keyup", "input"].forEach(type => this.element.removeEventListener(type, this.onEvent, true));
  }

  get isOpen() {
    return this.element.classList.contains("mobile-filters--open");
  }

  holdBack(event) {
    if (this.applying || !this.isOpen || !this.isMobileLayout) return;
    if (event.target.closest("[data-mobile-filters-keep]")) return;

    event.stopPropagation();
    if (event.type === "change") this.changed = event.target;
  }

  toggle() {
    this.setOpen(!this.isOpen);
  }

  apply() {
    this.setOpen(false);
    if (!this.changed) return;

    const field = this.changed;
    this.changed = null;
    this.applying = true;
    try {
      field.dispatchEvent(new Event("change", { bubbles: true }));
    } finally {
      this.applying = false;
    }
  }

  setOpen(open) {
    this.element.classList.toggle("mobile-filters--open", open);
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", String(open));
    this.updateCount();
  }

  updateCount() {
    if (!this.hasCountTarget) return;
    const fields = Array.from(this.element.querySelectorAll(
      "select[name], input[name]:not([type='hidden']):not([type='checkbox']):not([type='radio'])"
    ));
    const count = fields.filter(field => !field.closest("[data-mobile-filters-keep]") && this.hasValue(field)).length;
    this.countTarget.textContent = count > 0 ? `(${count})` : "";
  }

  hasValue(field) {
    if (field.tagName === "SELECT") return Array.from(field.selectedOptions).some(option => option.value !== "");
    return (field.value || "").trim() !== "";
  }
}
